query me {
  me {
    pk
    email
    name
    emailMd5
    settings(name: "location")
  }
}
